module.exports = __webpack_public_path__ + "static/edonarexhepi-69b051dd60bc63146a8f521e06317518.jpeg";